import {

  SET_GENERAL_FIELD,
  SET_GENERAL_ERRORS,
  GENERAL_REQUEST_LOADING,
  GENERAL_REQUEST_LOADED,

  GENERAL_SWITCH_THEME,

  SET_NOTIFICATIONS,
  APPEND_NOTIFICATIONS,
  DISMISS_NOTIFICATION,
  CLEAR_NOTIFICATIONS,

  GENERAL_SET_SELECTED_NOTIFICATION,
  GENERAL_SET_PUSH_REDIRECT,
  GENERAL_CLEAR_PUSH_REDIRECT,

  SAVE_PREFERENCE,
  SET_PREFERENCE,
  GENERAL_PREFERENCE_FIELD_CHANGED,

  FEEDBACK_SUBMIT,
  FEEDBACK_SUBMIT_FAILED,
  FEEDBACK_SUBMIT_SUCCESS,

  SNACKBAR_SET,
  SNACKBAR_RESET,

  MODAL_FORM_SET,
  MODAL_FORM_SET_COMPONENT,
  MODAL_FORM_TOGGLE,
  MODAL_FORM_RESET,

  SET_CLIENT_VERSION,

  LOG_CLIENT_ERRORS,
  LOG_CLIENT_ERRORS_SUCCESS,
  LOG_CLIENT_ERRORS_FAIL,

  GENERAL_UPDATE_LIST_APPEND,
  GENERAL_UPDATE_LIST_APPEND_FAIL,
  GENERAL_UPDATE_LIST_APPEND_SUCCESS,

  LOGOUT
} from '../actions/types';

export const INITIAL_STATE = {
  preferences: {
    bloglist: true,
    podcastlist: true,
    newsletterlist: true,
    productupdatelist: true,
  },
  snackbar: {
    message: '',
    open: false,
    vertical: 'bottom',
    horizontal: 'center',
    severity: 'notificationBarHide',
  },
  lastClientLog: '',
  modalForm: {
    contentComponent: '',
    data: '',
    open: false
  },
  notifications:{

  },
  updateNotesList: [],
  version: '',
  serverStatus: 0,
  chosenTheme: false,
  error: false,
  errors: {},
  loading: false,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GENERAL_REQUEST_LOADING:
      return { ...state,
        snackbar : {
          ...INITIAL_STATE.snackbar
        },
        loading: true,
        error: false,
        errors: {},
      };
    case GENERAL_REQUEST_LOADED:
      return { ...state,
        loading: false,
      };
    case SET_GENERAL_FIELD:
      return { ...state,
        [action.fieldName]: action.fieldValue
      };
    case SET_GENERAL_ERRORS:
      return {
        ...state,
        loading: false,
        error: true,
        errors: action.errors
      }
    case GENERAL_SET_SELECTED_NOTIFICATION:
      return { ...state,
        notificationSelected: action.value,
        notificationSelectedDate: action.date
      }
    case GENERAL_SET_PUSH_REDIRECT:
      return { ...state,
        pushRedirect: action.value,
      }
    case GENERAL_CLEAR_PUSH_REDIRECT:
      return { ...state,
        pushRedirect: ''
      }
    case SAVE_PREFERENCE:
      return { ...state,
        loading: false,
      };
    case SET_NOTIFICATIONS:
      return { ...state,
        loading: false,
        notifications: action.data.notifications
      };
    case APPEND_NOTIFICATIONS:
      return { ...state,
        loading: false,
        notifications: {...state.notifications, ...action.data.notifications}
      };
    case DISMISS_NOTIFICATION:
      return { ...state,
        notifications: {...(Object.fromEntries(Object.entries(state.notifications).filter(([key, value]) => key !== action.dismissedNote)))}
      } 
    case CLEAR_NOTIFICATIONS:
      return { ...state,
        loading: false,
        notifications: {}
      };
    case SET_PREFERENCE:
      return { ...state,
        preferences: {
          ...state.preferences,
          ...action.preferences
        },
        snackbar : {
          ...INITIAL_STATE.snackbar
        },
        loading: false,
      };
    case GENERAL_PREFERENCE_FIELD_CHANGED:
      return { ...state,
        preferences: {
          ...state.preferences,
          [action.fieldName]: action.fieldValue
        }
      };
    case FEEDBACK_SUBMIT:
      return {
        ...state,
        loading: true,
        error: false,
        errors: {},
      };
    case FEEDBACK_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        errors: {},
      };
    case FEEDBACK_SUBMIT_FAILED:
      return {
        ...state,
        loading: false,
        error: false,
        errors: {},
      };
    
    case SNACKBAR_SET:
      return {
        ...state,
        snackbar: {
          message: action.message,
          open: true,
          vertical: action.vertical,
          horizontal: action.horizontal,
          severity: action.severity,
        }
      }
    case SNACKBAR_RESET:
      return { ...state, snackbar: { ...INITIAL_STATE.snackbar } };
    case MODAL_FORM_SET:
      return {
        ...state,
        modalForm: {
          ...state.modalForm,
          contentComponent: action.contentComponent,
          data: action.data,
          open: action.open
        }
      };
    case MODAL_FORM_SET_COMPONENT:
      return {
        ...state,
        modalForm: {
          ...state.modalForm,
          contentComponent: action.contentComponent,
          open: action.open
        }
      };
    case MODAL_FORM_TOGGLE:
      return {
        ...state,
        modalForm: {
          ...state.modalForm,
          open: action.toggle
        }
      };
    case MODAL_FORM_RESET:
      return { ...state, modalForm: { ...INITIAL_STATE.modalForm } }
    case SET_CLIENT_VERSION:
      return {
        ...state,
        version: action.payload
      };  
    case LOG_CLIENT_ERRORS:
      return {
        ...state,
        loading: false,
        error: false,
        errors: {},
      }
    case LOG_CLIENT_ERRORS_SUCCESS:
      return {
        ...state,
        lastClientLog: action.data.lastClientLog,
        loading: false,
        error: false,
        errors: {},
      }
    case LOG_CLIENT_ERRORS_FAIL:
      return {
        ...state,
        loading: false,
        error: false,
        errors: {},
      }

    case  GENERAL_UPDATE_LIST_APPEND:
      return {
        ...state,
        loading: true,
        error: false,
        errors: {},
      }
    case GENERAL_UPDATE_LIST_APPEND_FAIL:
      return {
        ...state,
        loading: false,
        error: action.errors,
        errors: {},
      }
    case GENERAL_UPDATE_LIST_APPEND_SUCCESS:
      const oldItems = Object.values(state.updateNotesList).filter(updateItem => !action.data.updateItems.some(newUpdateItem => newUpdateItem.VERSION === updateItem.VERSION));
      return { ...state, 
        error: false, 
        errors: {}, 
        loading: false, 
        updateNotesList: oldItems.concat(action.data.updateItems),
      }
    case GENERAL_SWITCH_THEME:  
      return {...state, chosenTheme: (state.chosenTheme == 'dark')? 'light': 'dark'}
    case LOGOUT:
      return {...INITIAL_STATE, chosenTheme: state.chosenTheme};
    default:
      return state;

  }
};

export default reducer;